import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a0a271c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MainPanel" }
const _hoisted_2 = { class: "MainPanel__tab" }
const _hoisted_3 = { class: "MainPanel__content" }

import { computed } from 'vue';
import EmptyTeamGuide from '@/components/EmptyTeamGuide.vue';
import TeamList from '@/components/TeamList.vue';
import RankList from '@/components/RankList.vue';
import { useStore } from '@/store';
import { useUpdateTeamRank } from '@/hooks/useUpdateTeamRank';
import { useUpadeMainPageData } from '@/hooks/useUpadeMainPageData';
import { useTrack } from '@/hooks/useTrack';
import { useLogin } from '@/hooks/uselogin';
import types from '@/store/types';
import { useOffline } from '@/hooks/useOffline';



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const { clickLogin } = useLogin();
const { showOffline, offlineToast } = useOffline();

const activeTab = computed<number>({
  get: () => store.state.activityTab,
  set: (val) => store.commit(types.SET_CURRENT_TAB, val)
});

const hasTeam = computed(() => store.state.currentMembers.length > 0);
const hasRank = computed(() => store.state.teamRanks.length > 0);

const { trackBtn } = useTrack();

function switchTab (index: number) {
  if (showOffline.value) {
    offlineToast('活动暂时下线，期待更好玩的组队活动吧');
    return;
  }
  if (clickLogin()) {
    activeTab.value = index;
    if (index === 1) {
      trackBtn('队伍榜单');
      useUpdateTeamRank();
    } else {
      useUpadeMainPageData();
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["MainPanel__left", { 'MainPanel__left--active': _unref(activeTab) === 0 }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (switchTab(0)))
      }, " 我的队伍 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["MainPanel__right", { 'MainPanel__right--active': _unref(activeTab) === 1 }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (switchTab(1)))
      }, " 队伍榜单 ", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(activeTab) === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(hasTeam))
              ? (_openBlock(), _createBlock(TeamList, { key: 0 }))
              : (_openBlock(), _createBlock(EmptyTeamGuide, {
                  key: 1,
                  mode: "team"
                }))
          ], 64))
        : _createCommentVNode("", true),
      (_unref(activeTab) === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(hasRank))
              ? (_openBlock(), _createBlock(RankList, { key: 0 }))
              : (_openBlock(), _createBlock(EmptyTeamGuide, {
                  key: 1,
                  mode: "rank"
                }))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})